
<s1-input-label [label]="label" [append]="append">
  <input #input class="form-control {{ customClass }}" [ngClass]="{'is-invalid' : !checkIsValid() }" type="{{ type }}" [formControl]="control" [readonly]="readonly" mask="{{ mask }}" thousandSeparator="{{ thousandSeparator }}" decimalMarker="{{ decimalMarker }}" [allowNegativeNumbers]="allowNegativeNumbers" />
</s1-input-label>

